import axios from "axios";

import Config from "../../config";

const actionCampanhasEstimativa = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/campanhas/estimativa`,   
        data
    });
};

export default actionCampanhasEstimativa;
